import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  alertReducer,
  dniReducer,
  idCrmReducer,
  idLoginReducer,
  idUserReducer,
  tenantReducer,
  loadingReducer,
  tenantsReducer,
  userTypeReducer,
  userAliasReducer,
  searchTabReducer,
} from "../reducers";

const reducers = combineReducers({
  dni: dniReducer,
  idCrm: idCrmReducer,
  idUser: idUserReducer,
  idLogin: idLoginReducer,
  loading: loadingReducer,
  alert: alertReducer,
  tenant: tenantReducer,
  tenants: tenantsReducer,
  searchTab: searchTabReducer,
  userType: userTypeReducer,
  userAlias: userAliasReducer,
});

const configureStore = (preloadedState) => {
  const store = createStore(reducers, preloadedState, composeWithDevTools(applyMiddleware(thunk, createLogger())));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      store.replaceReducer(reducers);
    });
  }

  return store;
};

export default configureStore;
